import cookie from 'react-cookie';
import uuidV1 from 'uuid/v1';

const identitySelector = ({ user }) => {
  const anonymousId = cookie.load('ajs_anonymous_id') ?
    cookie.load('ajs_anonymous_id')
    : uuidV1();
  const email = user.details ? user.details.email : null;
  const id = user.details ? (user.details._id || user.details.usID) : anonymousId;
  if (!id) {
    return { id: 'unidentified' };
  }

  const idDoc = {
    id,
    anonymousId,
    email,
    entitlements: user.entitlements || null,
    identify: (!anonymousId && !user.details),
    type: user.details ? 'logged_in' : 'anonymous',
  };

  return idDoc;
};

export default identitySelector;



// WEBPACK FOOTER //
// ./src/common/features/identity.js